<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
      Campaign Stats
    </h3>
    <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Total Subscribers
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.totalSubscribers }}
            </dd>
          </dl>
        </div>
      </div>

      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Sent
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.sentSubscribers }}
            </dd>
          </dl>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              Failed
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-gray-900">
              {{ report.failedSubscribers }}
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      report: {}
    };
  },
  created() {
    const campaignId = this.$route.params.campaignId;
    this.$store
      .dispatch("Marketing/getCampaignReport", { campaignId })
      .then(response => {
        this.report = response.report;
      });
  }
};
</script>

<style lang="scss" scoped></style>
